var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5117 30.8475V25.08C30.5117 23.205 29.7669 21.4068 28.4411 20.0809C27.1152 18.7551 25.317 18.0103 23.442 18.0103H9.30244C7.42742 18.0103 5.62919 18.7551 4.30335 20.0809C2.97751 21.4068 2.23267 23.205 2.23267 25.08V30.8475",
    stroke: "#0056CD",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.372 14.8836C20.071 14.8836 23.0697 11.885 23.0697 8.18596C23.0697 4.48693 20.071 1.48828 16.372 1.48828C12.673 1.48828 9.67432 4.48693 9.67432 8.18596C9.67432 11.885 12.673 14.8836 16.372 14.8836Z",
    stroke: "#0056CD",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5765 21.5131C19.4128 21.3463 19.2185 21.2139 19.0047 21.1236C18.7908 21.0333 18.5616 20.9868 18.3301 20.9868C18.0986 20.9868 17.8693 21.0333 17.6555 21.1236C17.4416 21.2139 17.2473 21.3463 17.0837 21.5131L16.744 21.8593L16.4044 21.5131C16.0738 21.1763 15.6255 20.987 15.158 20.987C14.6905 20.987 14.2421 21.1763 13.9115 21.5131C13.581 21.85 13.3953 22.307 13.3953 22.7834C13.3953 23.2598 13.581 23.7168 13.9115 24.0537L14.2512 24.3998L16.744 26.9403L19.2368 24.3998L19.5765 24.0537C19.7402 23.8869 19.8701 23.6888 19.9587 23.4709C20.0473 23.2529 20.0929 23.0193 20.0929 22.7834C20.0929 22.5475 20.0473 22.3139 19.9587 22.0959C19.8701 21.878 19.7402 21.6799 19.5765 21.5131V21.5131Z",
    stroke: "#0056CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0c41a25c.svg";
export { ForwardRef as ReactComponent };